/**
 * scrollbarThinCx
 */
export const scrollbarThinCx = cxm(
  "scrollbar scrollbar-w-1 scrollbar-thumb-accent scrollbar-track-background scrollbar-thumb-rounded-full"
)
